"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization of {@link PriceWithVat}.
 *
 * @author Jan Prokop
 */


var PriceWithVatConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceWithVatConverter, _DataObjectConverter_);

  function PriceWithVatConverter() {
    _classCallCheck(this, PriceWithVatConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceWithVatConverter).apply(this, arguments));
  }

  return PriceWithVatConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceWithVatConverter = PriceWithVatConverter;